import { render, staticRenderFns } from "./task-avatar.vue?vue&type=template&id=21ddb009&"
import script from "./task-avatar.vue?vue&type=script&lang=js&"
export * from "./task-avatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports